import styled from "styled-components";

import { ArrowRight } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

export const StyledLinkWidget = styled.div`
    width: 290px;
    height: 72px;
    padding: 16px;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    background: ${colorsPalettes.carbon[0]};
    border-radius: 16px;
    border: 1px solid ${colorsPalettes.blue[200]};
    box-sizing: border-box;
`;

export const StyledIconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 3px;
    border: 1px solid ${colorsPalettes.blue[200]};
`;

export const StyledArrowRight = styled(ArrowRight)`
    align-self: center;
`;
